import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Path } from 'portal/core/core.enums';
import { PlanSyncStore } from 'portal/core/plan-sync/plan-sync.store';

export const dashboardGuard: CanActivateFn = async () => {
  const router = inject(Router);
  const store = inject(PlanSyncStore);
  const questionnaire = router.createUrlTree(['/' + Path.QUESTIONNAIRE]);

  if (store.source() === 'local') {
    return store.isDone() || questionnaire;
  }

  // Every visit asks the server again; a failed request still lets the page open and show its
  // error state instead of sending the user to the questionnaire.
  const plan = await store.loadAccountPlan();

  return plan === 'empty' ? questionnaire : true;
};
